import React from 'react';
import { useOutletContext } from 'react-router-dom';
import FeedManagement from '../../components/Admin/Feed/FeedManagement';

const AdminFeed = () => {
  const { setIsLoading } = useOutletContext();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
          Gestion du feed
        </h1>
        <p className="text-slate-600 dark:text-slate-400 mt-2">
          Gérez les entreprises mises en avant dans le feed
        </p>
      </div>
      
      <FeedManagement setIsLoading={setIsLoading} />
    </div>
  );
};

export default AdminFeed; 